var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "chev_left",
  "use": "chev_left-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chev_left\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.744.25a.887.887 0 0 0-1.235 0L.256 5.396a.843.843 0 0 0 0 1.21l5.253 5.144a.887.887 0 0 0 1.235 0 .843.843 0 0 0 0-1.21L2.11 6l4.635-4.54a.843.843 0 0 0 0-1.21Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol